module.exports = __webpack_public_path__ + "img/img9.a9b3c28c.svg";